import { $el, $list } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../base-component'
import { Nullable } from 'src/scripts/types/common'
import { debounce } from 'src/scripts/utils/debounce'
import { FloatElement } from '../../float-element'

const COLLAPSED_TAGS_SELECTOR = '[data-collapsed-tags]'
const TAG_SELECTOR = '[data-tag]'
const EXTEND_BUTTON_SELECTOR = `[data-extend-button]`

export class ArticleTags extends BaseComponent {
  extendButton: Nullable<HTMLElement>
  extendButtonWidth: number
  maxBottomPoint: number
  resizeObserver: ResizeObserver

  constructor() {
    super()

    this.extendButton = $el(EXTEND_BUTTON_SELECTOR, this)
    this.extendButtonWidth = this.extendButton?.offsetWidth ?? 0
  }

  mountComponent(): void {
    this.resizeObserver = new ResizeObserver(this.handleContentResize)
    this.resizeObserver.observe(this)
  }

  unmountComponent(): void {
    this.resizeObserver.disconnect()
  }

  handleContentResize = debounce((): void => {
    this.update()
  }, 200)

  updateButtonVisible(): void {
    if (!this.extendButton) {
      return
    }

    const hiddenTags: NodeListOf<HTMLElement> =
      this.querySelectorAll('[tag-hidden]')
    const hasHiddenTags = hiddenTags.length > 0

    if (hasHiddenTags) {
      const left = hiddenTags[0].style.left
      this.extendButton.style.left = left
    }

    this.extendButton.classList.toggle('hidden', !hasHiddenTags)
  }

  updateTagsVisible(): void {
    const tags = $list(TAG_SELECTOR, this)

    const isToCollapse = tags.findIndex(
      tag => tag.getBoundingClientRect().bottom > this.maxBottomPoint,
    )

    if (isToCollapse === -1) {
      return
    }

    const tagsToCollapse = tags.slice(isToCollapse - 1)

    const hiddenTags: FloatElement = $el(COLLAPSED_TAGS_SELECTOR, this)
    const collapsedTagsFragment = document.createDocumentFragment()

    tagsToCollapse.forEach(tag => {
      const clone = tag.cloneNode(true)
      tag.setAttribute('tag-hidden', '')
      collapsedTagsFragment.appendChild(clone)
    })

    hiddenTags?.element.replaceChildren(collapsedTagsFragment)
  }

  update(): void {
    this.maxBottomPoint = this.getBoundingClientRect().bottom

    if (this.maxBottomPoint > 0) {
      this.updateTagsVisible()
      this.updateButtonVisible()

      this.setAttribute('visible', '')
    }
  }
}
